"use strict";
// MIT License
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2GetBlockSolve = exports.b2SetBlockSolve = exports.b2World = exports.b2BodyType = exports.b2Body = void 0;
// Copyright (c) 2019 Erin Catto
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
__exportStar(require("./common/b2_common"), exports);
__exportStar(require("./common/b2_settings"), exports);
__exportStar(require("./common/b2_math"), exports);
__exportStar(require("./common/b2_draw"), exports);
__exportStar(require("./common/b2_draw_helper"), exports);
__exportStar(require("./common/b2_timer"), exports);
__exportStar(require("./common/b2_augment"), exports);
__exportStar(require("./collision/b2_collision"), exports);
__exportStar(require("./collision/b2_distance"), exports);
__exportStar(require("./collision/b2_broad_phase"), exports);
__exportStar(require("./collision/b2_dynamic_tree"), exports);
__exportStar(require("./collision/b2_time_of_impact"), exports);
__exportStar(require("./collision/b2_collide_circle"), exports);
__exportStar(require("./collision/b2_collide_polygon"), exports);
__exportStar(require("./collision/b2_collide_edge"), exports);
__exportStar(require("./collision/b2_shape"), exports);
__exportStar(require("./collision/b2_circle_shape"), exports);
__exportStar(require("./collision/b2_polygon_shape"), exports);
__exportStar(require("./collision/b2_edge_shape"), exports);
__exportStar(require("./collision/b2_chain_shape"), exports);
__exportStar(require("./dynamics/b2_fixture"), exports);
var b2_body_1 = require("./dynamics/b2_body");
Object.defineProperty(exports, "b2Body", { enumerable: true, get: function () { return b2_body_1.b2Body; } });
Object.defineProperty(exports, "b2BodyType", { enumerable: true, get: function () { return b2_body_1.b2BodyType; } });
var b2_world_1 = require("./dynamics/b2_world");
Object.defineProperty(exports, "b2World", { enumerable: true, get: function () { return b2_world_1.b2World; } });
__exportStar(require("./dynamics/b2_world_callbacks"), exports);
__exportStar(require("./dynamics/b2_time_step"), exports);
__exportStar(require("./dynamics/b2_contact_manager"), exports);
__exportStar(require("./dynamics/b2_contact"), exports);
__exportStar(require("./dynamics/b2_contact_factory"), exports);
var b2_contact_solver_1 = require("./dynamics/b2_contact_solver");
Object.defineProperty(exports, "b2SetBlockSolve", { enumerable: true, get: function () { return b2_contact_solver_1.b2SetBlockSolve; } });
Object.defineProperty(exports, "b2GetBlockSolve", { enumerable: true, get: function () { return b2_contact_solver_1.b2GetBlockSolve; } });
__exportStar(require("./dynamics/b2_joint"), exports);
__exportStar(require("./dynamics/b2_area_joint"), exports);
__exportStar(require("./dynamics/b2_distance_joint"), exports);
__exportStar(require("./dynamics/b2_friction_joint"), exports);
__exportStar(require("./dynamics/b2_gear_joint"), exports);
__exportStar(require("./dynamics/b2_motor_joint"), exports);
__exportStar(require("./dynamics/b2_mouse_joint"), exports);
__exportStar(require("./dynamics/b2_prismatic_joint"), exports);
__exportStar(require("./dynamics/b2_pulley_joint"), exports);
__exportStar(require("./dynamics/b2_revolute_joint"), exports);
__exportStar(require("./dynamics/b2_weld_joint"), exports);
__exportStar(require("./dynamics/b2_wheel_joint"), exports);
__exportStar(require("./rope/b2_rope"), exports);
